/* eslint-disable */
import { Grid, List, ListItem, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, switchMap, tap } from 'rxjs/operators';
import sanitizeHtml from 'sanitize-html';
import withServices from '../../Contexts/Services/WithServices.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Spinner from '../Spinner/Spinner.component';
import SearchPropTypes from './Search.component.props';
import SearchStyles from './Search.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * Escape string for regex
 * @param {string} input string
 * @returns {string} escaped input string
 */
const escapeRegExp = (input) => input.replace(/[.*+?^${}()|[\]\\]/g, `\\$&`);

/**
 * Search
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const Search = ({ classes, searchBarInput = {}, excludedItems, onChange, currentAccount, itemsFrom }) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentKeyword, setCurrentKeyword] = useState(``);

  useEffect(() => {
    setIsLoading(true);
    const initialResultsSubscriber =
      itemsFrom &&
      itemsFrom(``, currentAccount).subscribe((result) => {
        setIsLoading(false);
        setItems(result);
      });

    const fromKeyDown$ = fromEvent(searchBarInput.current, `keydown`).pipe(
      debounceTime(300),
      filter((el) => el.target.value.length > 2 || el.target.value === ``),
      tap((el) => {
        setIsLoading(true);
        setCurrentKeyword(el.target.value);
      }),
      switchMap((el) => itemsFrom(el.target.value, currentAccount)),
    );

    const keyDownSubscriber = fromKeyDown$.subscribe((result) => {
      setIsLoading(false);
      setItems(result);
    });

    return () => {
      if (initialResultsSubscriber) {
        initialResultsSubscriber.unsubscribe();
      }
      keyDownSubscriber.unsubscribe();
    };
  }, []);

  const current = items
    // below looks for the only property on el object to make it more generic rather then target el.deliveryAddress etc
    .filter((el) => !excludedItems.includes(el[Object.keys(el)[0]]))
    .map((el) => {
      let highlitedItem = sanitizeHtml(el[Object.keys(el)[0]]);
      if (currentKeyword) {
        const escapedCurrentKeyword = escapeRegExp(currentKeyword);
        const highlightRegex = new RegExp(`(${escapedCurrentKeyword})`, `gi`);
        highlitedItem = highlitedItem.replace(highlightRegex, `<span style="background-color:${grey[300]}">$1</span>`);
      }
      return (
        <ListItem button classes={{ root: classes.listItemRoot }} key={el[Object.keys(el)[0]]} onClick={() => onChange(el[Object.keys(el)[0]])}>
          <Typography dangerouslySetInnerHTML={{ __html: highlitedItem }} variant="body2" data-mf-replace-inner={MFSDR}/>
        </ListItem>
      );
    });

  return (
    <React.Fragment>
      <Grid container>
        {!isLoading ? (
          <Grid item xs={12}>
            <List>{current}</List>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Spinner className={classes.spinner} />
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

Search.propTypes = SearchPropTypes;

export default compose(
  withServices,
  withStyles(themeCreateInjectableStyles(SearchStyles), { withTheme: true }),
)(Search);
